<template>
    <a-modal
        v-model:open="visible"
        title="修改密碼"
        wrap-class-name="edit-modal"
        :confirm-loading="loading"
        @ok="handleSubmit"
        @cancel="handleCancel"
        :mask-closable="false"
        :width="420"
        ok-text="確認"
        cancel-text="取消"
    >
        <a-form
            ref="formRef"
            :model="form"
            :rules="rules"
            layout="vertical"
        >
            <a-form-item label="目前密碼" name="currentPassword">
                <a-input-password
                    v-model:value="form.currentPassword"
                    placeholder="請輸入目前密碼"
                />
            </a-form-item>
            <a-form-item label="新密碼" name="password">
                <a-input-password
                    v-model:value="form.password"
                    placeholder="請輸入新密碼（至少 8 碼）"
                />
            </a-form-item>
            <a-form-item label="確認新密碼" name="confirmPassword">
                <a-input-password
                    v-model:value="form.confirmPassword"
                    placeholder="請再次輸入新密碼"
                />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script setup>
import { reactive, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import { changeManagerPassword } from '@/api/auth/changeManagerPassword';

const props = defineProps({
    open: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:open', 'success']);

const visible = ref(false);
const loading = ref(false);
const formRef = ref();

const form = reactive({
    currentPassword: '',
    password: '',
    confirmPassword: ''
});

const rules = {
    currentPassword: [
        { required: true, message: '請輸入目前密碼', trigger: 'blur' }
    ],
    password: [
        { required: true, message: '請輸入新密碼', trigger: 'blur' },
        { min: 8, message: '新密碼至少需要 8 個字元', trigger: 'blur' }
    ],
    confirmPassword: [
        { required: true, message: '請確認新密碼', trigger: 'blur' },
        {
            validator: (rule, value) => {
                if (!value) {
                    return Promise.reject(new Error('請確認新密碼'));
                }
                if (value !== form.password) {
                    return Promise.reject(new Error('兩次輸入的密碼不一致'));
                }
                return Promise.resolve();
            },
            trigger: 'blur'
        }
    ]
};

watch(
    () => props.open,
    (val) => {
        visible.value = val;
        if (val) {
            resetForm();
        }
    }
);

watch(visible, (val) => {
    emit('update:open', val);
});

const resetForm = () => {
    form.currentPassword = '';
    form.password = '';
    form.confirmPassword = '';
    formRef.value?.resetFields();
};

const handleSubmit = async () => {
    try {
        await formRef.value.validate();
        loading.value = true;

        const response = await changeManagerPassword(
            form.currentPassword,
            form.password
        );

        if (response.status === 1) {
            message.success('密碼修改成功');
            emit('success');
            handleCancel();
        } else {
            message.error(response.message || '密碼修改失敗');
        }
    } catch (error) {
        if (error?.errorFields) {
            return;
        }
        console.error('管理員修改密碼錯誤:', error);
        const msg =
            error?.response?.data?.message ||
            '密碼修改失敗，請稍後再試';
        message.error(msg);
    } finally {
        loading.value = false;
    }
};

const handleCancel = () => {
    visible.value = false;
    resetForm();
};
</script>

